import Mute from '../../../assets/mute.svg';

const MuteIcon = (props: React.SVGProps<SVGSVGElement> & { disabled?: boolean }): JSX.Element => {
  return <Mute fill={props.disabled ? '#868A90' : 'white'} {...props} />;
};

export default MuteIcon;
